
import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class ConditionCovenantRestriction {
    constructor(doc)
    {
		this.label = null
		this.restrictionDescription = null
		this.restrictionType = null
		this.restrictionTypeOtherDescription = null
		this.valueMarketabilityImpactType = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.restrictionDescription = x.getStringElement(doc, "./ns:RestrictionDescription");
		this.restrictionType = x.getStringElement(doc, "./ns:RestrictionType");
		this.restrictionTypeOtherDescription = x.getStringElement(doc, "./ns:RestrictionTypeOtherDescription");
		this.valueMarketabilityImpactType = x.getStringElement(doc, "./ns:ValueMarketabilityImpactType");
   }

	 GetCCRType() {
		return h.descriptionOrOther(this.restrictionType, this.restrictionTypeOtherDescription);
	 }
}

export class Easement {
    constructor(doc)
    {
		this.label = null
		this.easementDescription = null
		this.easementType = null
		this.easementTypeOtherDescription = null
		this.improvementInBoundaryOfEasementIndicator = null
		this.valueMarketabilityImpactType = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.easementDescription = x.getStringElement(doc, "./ns:EasementDescription");
		this.easementType = x.getStringElement(doc, "./ns:EasementType");
		this.easementTypeOtherDescription = x.getStringElement(doc, "./ns:EasementTypeOtherDescription");
		this.improvementInBoundaryOfEasementIndicator = x.getBooleanElement(doc, "./ns:ImprovementInBoundaryOfEasementIndicator");
		this.valueMarketabilityImpactType = x.getStringElement(doc, "./ns:ValueMarketabilityImpactType");
   }

	 GetEasementType() {
		return h.descriptionOrOther(this.easementType, this.easementTypeOtherDescription);
	 }
}

export class Encroachment {
    constructor(doc)
    {
		this.label = null
		this.encroachmentDescription = null
		this.encroachmentDirectionType = null
		this.encroachmentType = null
		this.encroachmentTypeOtherDescription = null
		this.valueMarketabilityImpactType = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.encroachmentDescription = x.getStringElement(doc, "./ns:EncroachmentDescription");
		this.encroachmentDirectionType = x.getStringElement(doc, "./ns:EncroachmentDirectionType");
		this.encroachmentType = x.getStringElement(doc, "./ns:EncroachmentType");
		this.encroachmentTypeOtherDescription = x.getStringElement(doc, "./ns:EncroachmentTypeOtherDescription");
		this.valueMarketabilityImpactType = x.getStringElement(doc, "./ns:ValueMarketabilityImpactType");
   }

	 GetEncroachmentType() {
		return h.descriptionOrOther(this.encroachmentType, this.encroachmentTypeOtherDescription);
	 }
}

export class EncumbranceDetail {
    constructor(doc)
    {
		this.label = null
		this.encumbranceType = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.encumbranceType = x.getStringElement(doc, "./ns:EncumbranceType");
   }
}

export class Encumbrance {
    constructor(doc)
    {
		this.label = null
		this.conditionCovenantRestrictions = []
		this.easements = []
		this.encroachments = []
		this.encumbranceDetail = null
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:CONDITION_COVENANT_RESTRICTIONS/ns:CONDITION_COVENANT_RESTRICTION");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.conditionCovenantRestrictions.push(new ConditionCovenantRestriction(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:EASEMENTS/ns:EASEMENT");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.easements.push(new Easement(xn));
			});
		}
		nodes = x.selectNodes(doc, "./ns:ENCROACHMENTS/ns:ENCROACHMENT");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.encroachments.push(new Encroachment(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:ENCUMBRANCE_DETAIL");
		if (node !== null)
				this.encumbranceDetail = new EncumbranceDetail(node);
   }

	 GetEncumbranceType() {
		return h.toEnumText(this.encumbranceDetail.encumbranceType);
	 }
}
